import { createTestId } from 'utils';
import React, { useState, useEffect, useContext, useRef } from "react"
import { useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom'
import { AppContext } from 'configuration/app-context'
import WebClient, { constants } from 'utils/webclient'
import * as ApiService from 'utils/api-service'
import User from "assets/img/user.png"
import ISpinner from "components/spinner/spinner";
import CustomSelect from "components/form-inputs/Select";

import { Formik } from "formik"
import * as Yup from "yup"
import IBigSpinner from "components/spinner/big-spinner";
import EmptyCard from "components/card/EmptyCard";
import { Doctor as DoctorIcon } from "components/icon";
import DOMPurify from 'dompurify'

const DoctorDetail = (props) => {

    const formikRef = useRef(null)
    
    const { translate } = useContext(AppContext)
    const [doctor, setDoctor] = useState(null);
    const [activeClass, setActiveClass] = useState("interest")
    const [loading, setLoading] = useState(false)
    const [isDetailLoading, setIsDetailLoading] = useState(true);
    const [tabData, setTabData] = useState("")
    const [insuranceCompanies, setInsuranceCompanies] = useState([])
    const [hospitals, setHospitals] = useState([])
    const [departments, setDepartments] = useState([])
    const [appointmentTypes, setAppointmentTypes] = useState([])
    const [disabled, setDisabled] = useState(false)

    const navigate = useNavigate()

    const patient = useSelector(state => state.patient)

    function setTab(elem, data) {
        setActiveClass(elem);
        setTabData(data);
    }

    async function GetDetail(doctorId) {
        let c = new WebClient();
        await c.post("503D61A530CA37/Detail", {
            doctorId
        }, false, false, false)
        .then(({ isSuccess, data }) => {
            if (isSuccess) {
                if ((data?.resource?.interest && data?.resource?.interest != "<p><br></p>" && data?.resource?.interest != "<p></p>" && data?.resource?.interest != "<br>")) {
                    setTabData(data?.resource?.interest ?? "")
                } else {
                    setActiveClass("education")
                    setTabData(data?.resource?.education ?? "")
                }
                setDoctor(data)
            }
        })
    }
    
    useEffect(() => {
        setIsDetailLoading(true);
        (async () => {
            await GetDetail(props.id)
        })();
    }, []);

    useEffect(() => {
        if(doctor){
            (async () => {
                await AppointmentTypeList()
                setIsDetailLoading(false);
            })()
        }
    }, [doctor])

    const AppointmentTypeList = async () => {
        let c = new WebClient();
        await c.post("573D6FBC30D637/FilterAppointmentTypes", {
            doctorId: props.id,
            codes: [constants.appointmentTypesCode.physical, constants.appointmentTypesCode.online, constants.appointmentTypesCode.tyto, constants.appointmentTypesCode.radiology]
        }, true)
        .then(({ isSuccess, exception, data }) => {
            if (isSuccess) {
                let a = data.map((e) => {
                    return {
                        ...e,
                        value: e.id,
                        label: e.name
                    }
                })
                setAppointmentTypes(a)

                if(a.length > 0){
                    let insurance_companies = doctor?.insuranceCompanies.map((e) => {
                        return {
                            value: e.value,
                            label: e.text
                        }
                    })
                    let _insurance_companies = [{ value: 0, label: translate("continue_without_select") }, ...insurance_companies]
                    setInsuranceCompanies(_insurance_companies)

                    console.log("formikREF-->", formikRef)

                    if(insurance_companies.length === 0){
                        console.log("formikRef-->", formikRef.current)
                        //formikRef.current.setFieldValue("insuranceCompany", _insurance_companies[0])
                    }
                }
                
            }
        })
    }       

    const GetHospitals = (insuranceId, appointmentTypeId, doctorId) => {
        setLoading(true)
        ApiService.FilterHospitalsByAppointmentType({insuranceId, appointmentTypeId, doctorId})
            .then((a) => {
                setHospitals(a)
                if (a.length == 1) {
                    GetDepartments(doctorId, appointmentTypeId, a[0].value, true)
                    formikRef.current.setFieldValue("hospital", a[0])
                } 
                setLoading(false)
            })
    }

    const GetDepartments = (doctorId, appointmentTypeId, hospitalId, enableCheckSpecialDoctor) => {
        setLoading(true)
        ApiService.FilterDepartments({doctorId, appointmentTypeId, hospitalId, enableCheckSpecialDoctor})
        .then((a) => {
            let _a = a.map((e) => {
                return {
                    value: e.id,
                    label: e.name
                }
            })
            setDepartments(_a)
            if (a.length == 1) {
                formikRef.current.setFieldValue("department", _a[0])
            } else if (a.length == 0) { 
                setDisabled(true)
            }
            setLoading(false)
        })
    }     

    if (isDetailLoading) return <IBigSpinner size='sm' />;

    if (doctor == null) return (
        <div className="w-full h-64 flex flex-col items-center justify-center">
            <EmptyCard icon={DoctorIcon} label={translate("no_doctor_detail_title")} />
        </div>
    )    

    return (
        <>
        <div className="background-cover overflow-auto">
            <div className="card bg-transparent shadow-none">
                <div className="card-body flex flex-row items-center gap-4 p-0">
                    <div className="media image-cover">
                        <img src={doctor.photo ? doctor.photo : User} alt={doctor.name} title={doctor.title + " " + doctor.name} />
                    </div>
                    <div className="relative">
                        <h6 className="font-medium text-white">{doctor.title} {doctor.name}</h6>
                        <ul className="list">
                            {Array.from(new Set(doctor.departments?.map((item) => item.hospitalName )))
                                .map((hospitalName, i) => (<li key={i}>{hospitalName}</li>))
                            }
                        </ul>
                        <p className="text-sm text-white">{Array.from(new Set(doctor.departments?.map((e) => { return e.resource?.name }))).join(", ")}</p>
                    </div>
                </div>
            </div>
        </div>

        <div className="flex justify-center">
            <ul className="nav nav-tabs">

                {
                    (doctor?.resource?.interest && doctor?.resource?.interest != "<p><br></p>" && doctor?.resource?.interest != "<p></p>" && doctor?.resource?.interest != "<br>") && (
                    <li className="nav-item">
                        <button className={`${activeClass == 'interest' ? 'nav-link active' : 'nav-link'}`} data-testid={createTestId('button', 'DoctorDetail', 1)} onClick={() => { setTab("interest", doctor?.resource.interest); }}>{translate("interest")}</button>
                    </li>
                    ) 
                }
                {
                    doctor?.resource?.education && (
                    <li className="nav-item">
                        <button className={`${activeClass == 'education' ? 'nav-link active' : 'nav-link'}`} data-testid={createTestId('button', 'DoctorDetail', 2)} onClick={() => { setTab("education", doctor?.resource.education); }}>{translate("education")}</button>
                    </li>
                    ) 
                }
                {
                    doctor?.resource?.career && (
                    <li className="nav-item">
                        <button className={`${activeClass == 'career' ? 'nav-link active' : 'nav-link'}`} data-testid={createTestId('button', 'DoctorDetail', 3)} onClick={() => { setTab("career", doctor?.resource.career); }}>{translate("career")}</button>
                    </li>
                    ) 
                }
            </ul>
        </div>

        <div className="card mb-4 custom-shadow" >
            <div className="card-body p-4">
                {
                tabData == "" ?
                <p className="text-center text-sm text-neutral-400">{translate("detail_not_found")}</p>
                :
                <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(tabData) }}></div>
                }
                
            </div>
        </div>

        {
            appointmentTypes.length > 0 && (
                <Formik
                    innerRef={formikRef}
                    initialValues={{
                        insuranceCompany: insuranceCompanies.length === 1 ? insuranceCompanies[0] : "",
                        appointmentType: appointmentTypes.length === 1 ? appointmentTypes[0] : "",
                        hospital: hospitals.length === 1 ? hospitals[0] : "",
                        department: departments.length === 1 ? departments[0] : ""
                    }}
                    validationSchema={Yup.object().shape({
                        insuranceCompany: Yup.object().required(translate("validation_message_empty_insurance_company")),
                        appointmentType: Yup.object().required(translate("validation_message_empty_appointment_type")),
                        hospital: Yup.object().required(translate("validation_message_empty_hospital")),
                        department: Yup.object().required(translate("validation_message_empty_department"))
                    })}
                    onSubmit={(values, { setSubmitting, resetForm, setError, setFieldValue })  => {
                        console.log("values-->", values)
                        navigate("/appointment", {
                            state: {
                                pre: {
                                    packageGrade: 0,
                                    packageGradeService: 0,
                                    insurance: values.insuranceCompany.value,
                                    appointmentTypeId: values.appointmentType.value, 
                                    hospital: values.hospital.value,
                                    department: values.department.value,
                                    doctor: doctor.id
                                }
                            }
                        })
                    }}
                >
                    {({ errors, touched, values, isSubmitting, handleChange, handleSubmit, setValues, handleBlur, setFieldValue, submitForm, resetForm, setErrors }) => (
                    <>


        
                    <CustomSelect
                        label={translate("label_insurance_company")}
                        placeholder={loading ? translate("loading") : translate("placeholder_insurance_company")}
                        value={values.insuranceCompany}
                        name="insuranceCompany"
                        options={insuranceCompanies}
                        isSearchable={true}
                        onChange={(e) => { 
                            setValues({
                                insuranceCompany: e,
                                appointmentType: appointmentTypes.length === 1 ? appointmentTypes[0] : "",
                                hospital: "",
                                department: ""
                            })
                            if(appointmentTypes.length === 1){
                                GetHospitals(e.value, appointmentTypes[0].value, props.id)
                            }
                        }}
                        /> 
            
                    {
                    (values?.insuranceCompany) && (
                        <CustomSelect
                            label={translate("label_appointment_type")}
                            placeholder={loading ? translate("loading") : translate("placeholder_appointment_type")}
                            value={values.appointmentType}
                            name="appointmentType"
                            options={appointmentTypes}
                            showErrorLabel={true}
                            error={touched.appointmentType && errors.appointmentType ? errors.appointmentType : ""}
                            isSearchable={true}
                            onChange={(e) => { 
                                setValues({
                                    ...values,
                                    appointmentType: e,
                                    hospital: "",
                                    department: ""
                                })
                                GetHospitals(values.insuranceCompany.value, e.value, props.id)
                            }}
                        /> 
                    )
                    }
        
                    {
                    (values?.insuranceCompany && values?.appointmentType) && (
                    <CustomSelect
                        label={translate("label_hospital")}
                        placeholder={loading ? translate("loading") : translate("placeholder_hospital")}
                        value={values.hospital}
                        name="hospital"
                        options={hospitals}
                        showErrorLabel={true}
                        error={errors.hospital && touched.hospital ? errors.hospital : ''}
                        isSearchable={true}
                        onChange={(e) => { 
                            GetDepartments(props.id, values.appointmentType?.value, e.value, true)
                            setValues({
                                ...values,
                                hospital: e,
                                department: ""
                            })
                        }}
                    />                 
                    )
                    }   
        
                    {
                    (values?.insuranceCompany && values?.hospital) && (
                    <CustomSelect
                        label={translate("label_department")}
                        placeholder={loading ? translate("loading") : translate("placeholder_department")}
                        value={values.department}
                        name="department"
                        options={departments}
                        showErrorLabel={true}
                        error={errors.department && touched.department ? errors.department : ''}
                        isSearchable={true}
                        onChange={(e) => { 
                            setFieldValue("department", e)
                        }}
                    />                 
                    )
                    }
        
                    <button 
                        disabled={isSubmitting || loading || disabled }
                        data-testid={createTestId('button', 'DoctorDetail', 4)} onClick={() => handleSubmit()}
                        className="btn btn-gradient-primary lg:mt-auto mx-auto disabled:opacity-40">
                        {(isSubmitting || loading) ? <ISpinner /> : translate("make_appointment")}
                    </button>
        
                    </>
                    )}
                </Formik>
            )
        }




        
        </>
    )
}

export default DoctorDetail